<template>
  <div>
    <Header></Header>
    <searchShop
      :mch="ttshop_goodsxinxi.mch"
      :customer_service="customer_service"
      :goods="ttshop_goodsxinxi"
      :store="store.store"
      ref="searnum"
    ></searchShop>
    <div class="bannershoper" v-if="false"></div>
    <Nav></Nav>
    <!-- 面包屑 -->
    <div class="crumb crumbed" v-if="false">
      <div class="w">
        <div class="nav d-flex align-items-center">
          <div class="nav-item d-flex align-items-center">首页</div>
          <img
            class="img-default nav-img"
            src="../../assets/images/rigth.png"
            alt
          />
          <dl class="nav-items">
            <dt class="d-flex align-items-center">
              <div>女装</div>
              <img
                class="img-default nav-xia"
                src="../../assets/images/top_xia.png"
                alt
              />
            </dt>
            <dd class="d-flex flex-wrap">
              <div v-for="item in 25" :key="item">女装</div>
            </dd>
          </dl>
          <img
            class="img-default nav-img"
            src="../../assets/images/rigth.png"
            alt
          />
          <div class="nav-option d-flex align-items-center">
            品牌：
            <span>菲乐(FELE)</span>
            <span>、</span>
            <span>耐克</span>
            <img
              class="img-default nav-del"
              src="../../assets/images/nav_del.png"
              alt
            />
          </div>
          <div class="nav-option d-flex align-items-center">
            品牌：
            <span>菲乐(FELE)</span>
            <span>、</span>
            <span>耐克</span>
            <img
              class="img-default nav-del"
              src="../../assets/images/nav_del.png"
              alt
            />
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="w">
        <!-- 面包屑 -->
        <div class="nav d-flex align-items-center">
          <div class="nav-item d-flex align-items-center">
            <router-link to="/">首页</router-link>
          </div>
          <img
            class="img-default nav-img"
            src="../../assets/images/rigth.png"
            alt
            v-if="ttshop_catlist.length"
          />
          <div class="d-flex align-items-center" v-if="ttshop_catlist.length">
            <dl
              class="nav-items d-flex align-items-center"
              v-for="(item, index) in ttshop_catlist"
              :key="index"
            >
              <dt class="d-flex align-items-center">
                <div v-for="(i, b) in item" :key="b" v-if="i.is_sel == 1">
                  {{ i.name }}
                </div>
                <img
                  class="img-default nav-xia"
                  src="../../assets/images/top_xia.svg"
                  alt
                />
              </dt>
              <dd class="d-flex flex-wrap">
                <div v-for="(i, b) in item" :key="b" @click="sort(i.id)">
                  {{ i.name }}
                </div>
              </dd>
              <img
                class="img-default nav-img"
                src="../../assets/images/rigth.png"
                alt
                v-if="index != ttshop_catlist.length - 1"
              />
            </dl>
          </div>
        </div>
        <!-- 商品属性 -->
        <div class="goods d-flex justify-content-between">
          <!-- 左边图片 -->
          <div class="goods-l">
            <div class="img">
              <!-- <img class="img-default" :src="" alt :onerror="errorImg" /> -->
              <pic-zoom
                :url="ttshop_goodsxinxi.cover_pic"
                :scale="1.5"
              ></pic-zoom>
              <div
                class="video-btn"
                @click="videoShow()"
                v-if="ttshop_goodsxinxi.video_url"
              ></div>
              <template v-if="video_show">
                <video
                  preload="auto"
                  controls="controls"
                  :autoplay="autoplay"
                  @ended="videoShow()"
                  class="goods-video"
                  :src="ttshop_goodsxinxi.video_url"
                >
                  <p>您的浏览器不支持 HTML 5 Video 标签，请升级浏览器。</p>
                </video>
                <div class="video-close" @click="videoShow()">×</div>
              </template>
            </div>
            <div
              class="img-list d-flex justify-content-between align-items-center"
              :style="{
                padding:
                  ttshop_goodsxinxi.pic_list.length <= 6 ? '0 0' : '0 38px',
              }"
            >
              <div class="swiper-container goods-img swiper-no-swiping">
                <div class="swiper-wrapper">
                  <div
                    class="swiper-slide img-item"
                    v-for="(item, index) in ttshop_goodsxinxi.pic_list"
                    :key="index"
                    @mouseenter="enters(item.pic_url)"
                  >
                    <img
                      class="img-default"
                      :src="item.pic_url"
                      alt=""
                      :onerror="errorImg"
                    />
                  </div>
                </div>
              </div>
              <div
                class="btn-l swiper-button-prev"
                v-if="ttshop_goodsxinxi.pic_list.length > 6"
              >
                <img
                  class="img-default"
                  src="../../assets/images/img_left.png"
                  alt
                />
              </div>
              <div
                class="btn-r swiper-button-next"
                v-if="ttshop_goodsxinxi.pic_list.length > 6"
              >
                <img
                  class="img-default"
                  src="../../assets/images/img_right.png"
                  alt
                />
              </div>
            </div>

            <div class="goods-l-btn d-flex">
              <template v-if="false">
                <div class="item d-flex align-items-center">
                  <div class="item-img"></div>
                  对比
                </div>
                <div class="item d-flex align-items-center">
                  <div class="item-img"></div>
                  分享
                </div>
              </template>
              <div
                class="item d-flex align-items-center"
                @click="favoriteCilck"
              >
                <template v-if="ttshop_goodsxinxi.is_favorite == 1">
                  <i class="el-icon-star-on" style="color: #ff0e25"></i>已关注
                </template>
                <template v-else>
                  <i class="el-icon-star-off"></i>关注
                </template>
              </div>
            </div>
          </div>
          <!-- 中间 -->
          <div
            class="goods-c"
            :style="{
              width:
                ttshop_goodsxinxi.look_and_see &&
                ttshop_goodsxinxi.look_and_see.length
                  ? '550px'
                  : '749px',
            }"
          >
            <div class="name">{{ ttshop_goodsxinxi.name }}</div>
            <div class="name-item">{{ ttshop_goodsxinxi.subtitle }}</div>
            
            <div class="advance" v-if="ttshop_goodsxinxi.pre_detail">
              <div class="advance_time">
                <p class="time_title">预售剩余:</p>
                <div class="time_date">
                  <p>{{time_num.day}}</p>天 <p>{{time_num.hour}}</p>时 <p>{{time_num.minute}}</p>分 <p>{{time_num.second}}</p>秒
                </div>
              </div>
              <div class="advance_book">
                <div class="reservation">已预订 <span>{{ttshop_goodsxinxi.pre_detail.dep_num}}</span> 件</div>
                <div class="regulation" @click="flow_scheme">
                  <img src="../../assets/images/icon_must.png" alt="" />
                  <p>预售规则</p>
                </div>
              </div>
            </div>
            <div class="pic" v-if="!ttshop_goodsxinxi.pre_detail">
              <div class="pic-top">
                市场价
                <del>¥ {{ ttshop_goodsxinxi.original_price }}</del>
              </div>
              <div class="pic-bottom">
                售价
                <template v-if="ttshop_goodsxinxi.is_negotiable == 0">
                  <span>¥</span>
                  <span>{{
                    goods_attr_info.price || ttshop_goodsxinxi.min_price
                  }}</span>
                </template>
                <template v-else>
                  <span></span>
                  <span>{{ ttshop_goodsxinxi.min_price }}</span>
                </template>
              </div>
            </div>
            <div class="pic" v-else>
               <div class="pic-top">
                预售价
                <span>¥ {{ ttshop_goodsxinxi.pre_detail.pre_price }}</span>
              </div>
              <div class="pic-bottom pre_pic_bottom">
                定金
                  <span>￥</span>
                  <span>{{ttshop_goodsxinxi.pre_detail.deposit_price}}</span>
                  <p class="deduction">可抵￥{{ttshop_goodsxinxi.pre_detail.offset_price}}</p>
              </div>
            </div>
            <!-- 优惠券 -->
            <!-- <div class="coupon d-flex align-items-center">
							<div class="coupon-name">优惠券</div>
							<div class="coupon-list d-flex">
								<div class="item d-flex">
									<div class="item-l d-flex justify-content-center align-items-center">¥10</div>
									<div class="item-r d-flex justify-content-center align-items-center">满190减10</div>
								</div>
								<div class="item d-flex">
									<div class="item-l d-flex justify-content-center align-items-center">¥10</div>
									<div class="item-r d-flex justify-content-center align-items-center">满190减10</div>
								</div>
							</div>
							<div class="coupon-btn" @click="dialogFormVisible = true">共3张优惠券></div>
						</div> -->
            <!-- 促销 -->
            <div class="rush d-flex align-items-center">
              <div class="rush-name">促销</div>
              <div class="rush-list d-flex flex-wrap">
                <div
                  class="item d-flex justify-content-center align-items-center"
                  v-for="(item, index) in ttshop_goodsxinxi.service_list"
                  :key="index"
                >
                  {{ item }}
                </div>
              </div>
            </div>
            <!-- 单位 -->
            <div class="size d-flex align-items-center">
              <div class="size-name">单位</div>
              <div v-text="ttshop_goodsxinxi.unit"></div>
            </div>
            <!-- 数据 -->
            <div class="shownum d-flex align-items-center">
              <div
                class="
                  shownum-item
                  d-flex
                  justify-content-center
                  align-items-center
                "
              >
                总销量
                <span v-text="ttshop_goodsxinxi.sales"></span>
              </div>
              <div
                class="
                  shownum-item
                  d-flex
                  justify-content-center
                  align-items-center
                "
              >
                累计评价
                <span v-text="evaluateTab.score_all"></span>
              </div>
              <div
                class="
                  shownum-item
                  d-flex
                  justify-content-center
                  align-items-center
                "
              >
                赠送积分
                <span
                  style="color: #ff9010"
                  v-text="ttshop_goodsxinxi.give_integral"
                ></span>
              </div>
            </div>
            <!-- 尺码 -->
            <div
              class="size d-flex align-items-center"
              v-for="(item, index) in ttshop_goodsxinxi.attr_group_list"
              :key="index"
            >
              <div class="size-name">{{ item.attr_group_name }}</div>
              <div class="size-list d-flex flex-wrap flex_1">
                <div v-for="(items, index) in item.attr_list" :key="index">
                  <div
                    class="
                      items
                      d-flex
                      justify-content-center
                      align-items-center
                    "
                    v-if="items.attr_num_0"
                  >
                    {{ items.attr_name }}
                  </div>
                  <div
                    class="
                      item
                      d-flex
                      justify-content-center
                      align-items-center
                    "
                    @click="sizeClick(item.attr_group_id, items.attr_id)"
                    :class="{ size_active: items.active == true }"
                    v-else
                  >
                    {{ items.attr_name }}
                    <div class="pitc" v-if="items.active">
                      <img
                        class="img-default"
                        src="../../assets/images/brand.png"
                        alt
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 套餐 -->
            <div
              class="color d-flex align-items-center"
              v-if="setList && setList.length"
            >
              <div class="color-name">套餐</div>
              <ul class="color-list d-flex flex_1 flex-wrap">
                <li
                  class="item d-flex"
                  v-for="(item, index) in setList"
                  :key="index"
                >
                  <div
                    class="
                      item-txt
                      flex_1
                      d-flex
                      justify-content-center
                      align-items-center
                    "
                  >
                    {{ item.title }}
                  </div>
                  <div
                    class="d-flex flex-direction-column justify-content-between"
                    :class="['set', 'set' + index]"
                  >
                    <div class="setlist">
                      <div class="swiper-container set-item swiper-no-swiping">
                        <div class="swiper-wrapper">
                          <div
                            class="swiper-slide"
                            v-for="(items, idx) in item.goods_join"
                            :key="idx"
                          >
                            <div class="setitem">
                              <div class="setitem-img">
                                <img
                                  class="img-default"
                                  :src="items.cover_pic"
                                  alt=""
                                />
                              </div>
                              <div class="setitem-name">{{ items.name }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="setbtn-l swiper-button-prev"
                      v-if="item.goods_join.length > 3"
                    >
                      <img
                        class="img-default"
                        src="../../assets/images/img_left.png"
                        alt
                      />
                    </div>
                    <div
                      class="setbtn-r swiper-button-next"
                      v-if="item.goods_join.length > 3"
                    >
                      <img
                        class="img-default"
                        src="../../assets/images/img_right.png"
                        alt
                      />
                    </div>
                    <div
                      class="
                        setbottom
                        d-flex
                        align-items-center
                        justify-content-between
                      "
                    >
                      <div class="setbottom-l">
                        套装价：<span>¥{{ item.price }}</span>
                      </div>
                      <div
                        v-if="ttshop_goodsxinxi.status == 1"
                        class="
                          setbottom-btn
                          d-flex
                          align-items-center
                          justify-content-center
                        "
                        @click="setJoin(index)"
                      >
                        加入购物车
                      </div>
                      <div
                        v-else
                        class="
                          sold_out
                          setbottom-btn
                          d-flex
                          align-items-center
                          justify-content-center
                        "
                      >
                        加入购物车
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <!-- 数量 -->
            <div class="num d-flex align-items-center">
              <div class="num-name">数量</div>
              <el-input-number
                v-model="num"
                @change="handleChange"
                :min="1"
                :max="ttshop_goodsxinxi.vr_type == 1 ? 1 : ttshop_kcnum"
                label="描述文字"
              ></el-input-number>
            </div>
            <!-- 按钮 -->
            <div
              class="btn d-flex align-items-center"
              v-if="ttshop_goodsxinxi.status == 1"
            >
            <template v-if="ttshop_goodsxinxi.pre_detail">
                <div class="btn-buy d-flex justify-content-center align-items-center" @click="goodsSubmit(2)">定金购买</div>
            </template>
            <template v-else>
                <div
                class="btn-buy d-flex justify-content-center align-items-center"
                @click="goodsSubmit(2)"
              >
                立即购买
              </div>
              <div
                class="btn-cat d-flex align-items-center justify-content-center"
                @click="goodsSubmit(1)"
                v-if="ttshop_goodsxinxi.vr_type == 0"
              >
                <div class="btn-cat-img">
                  <img
                    class="img-default"
                    src="../../assets/images/cat_white.png"
                    alt
                  />
                </div>
                加入购物车
              </div>
            </template>
              
              <div
                class="
                  btn-phone
                  d-flex
                  align-items-center
                  justify-content-center
                "
                v-if="mobile_img"
              >
                <div class="btn-phone-l">
                  <img
                    class="img-default"
                    src="../../assets/images/cat_white.png"
                    alt
                  />
                </div>
                手机购买
                <div class="btn-phone-r">
                  <img
                    class="img-default"
                    src="../../assets/images/bottom_14.png"
                    alt
                  />
                </div>
                <div class="btn-phone-qr">
                  <div class="btn-phone-img">
                    <img :src="mobile_img" alt="">

                  </div>
                </div>
              </div>
            </div>
            <div class="btn d-flex align-items-center" v-else>
              <div
                class="
                  btn-buy
                  d-flex
                  justify-content-center
                  align-items-center
                  sold_out
                "
              >
                暂无上架
              </div>
              <!-- <div
                class="
                  btn-cat
                  d-flex
                  align-items-center
                  justify-content-center
                  sold_out
                "
                v-if="ttshop_goodsxinxi.vr_type == 0"
              >
                <div class="btn-cat-img">
                  <img
                    class="img-default"
                    src="../../assets/images/cat_white.png"
                    alt
                  />
                </div>
                加入购物车
              </div> -->
            </div>
          </div>
          <!-- 右边 -->
          <div
            class="goods-r"
            v-if="
              ttshop_goodsxinxi.look_and_see &&
              ttshop_goodsxinxi.look_and_see.length
            "
          >
            <div class="title d-flex align-items-center">
              <span></span>
              <div class="txt">看了又看</div>
              <span></span>
            </div>
            <div class="swiper-container list goods-look">
              <div class="swiper-wrapper">
                <template
                  v-for="(item, index) in ttshop_goodsxinxi.look_and_see"
                >
                  <div class="item swiper-slide" @click="toGoods(item.id)">
                    <img class="img-default" :src="item.pic_url" alt />
                    <!-- 价格面议 -->
                    <div
                      class="
                        pic
                        d-flex
                        align-items-center
                        justify-content-center
                      "
                      v-if="item.is_negotiable == 0"
                    >
                      ¥{{ item.price }}
                    </div>
                    <div
                      class="
                        pic
                        d-flex
                        align-items-center
                        justify-content-center
                      "
                      v-else
                    >
                      {{ item.price }}
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div class="btn d-flex justify-content-center align-items-center">
              <div class="btn-top swiper-button-prev">
                <img
                  class="img-default"
                  src="../../assets/images/img_left.png"
                  alt
                />
              </div>
              <div class="btn-bottom swiper-button-next">
                <img
                  class="img-default"
                  src="../../assets/images/img_left.png"
                  alt
                />
              </div>
            </div>
          </div>
        </div>
        <!-- 预售 -->
        <div class="presell" v-if="ttshop_goodsxinxi.pre_detail">
          <div class="presell_left">
            <img src="../../assets/images/jiangbei.png" alt="">
            <p>预售流程</p>
            <div class="pre_triangle">
              <div class="triangle_left"></div>
            </div>
          </div>
          <div class="technological">
            <div class="pay_advance">
              <div class="advance_indicate">
                <div class="instructions_kong"></div>
                <div class="instructions">1</div>
                <div class="instructions_xian"></div>
              </div>
              <div class="advance_title">支付定金</div>
              <div class="advance_time">{{ttshop_goodsxinxi.pre_detail.deposit_start_time_format}}</div>
            </div>
            <div class="pay_balance">
              <div class="balance_indicate">
                <div class="instructions_kong"></div>
                <div class="instructions">2</div>
                <div class="instructions_xian"></div>
              </div>
              <div class="advance_title">支付尾款（在我的订单完成）</div>
              <div class="advance_time">{{ttshop_goodsxinxi.pre_detail.final_end_time_format}}</div>
            </div>
            <div class="shipments">
              <div class="balance_indicate">
                <div class="instructions_kong"></div>
                <div class="instructions">3</div>
                <div class="instructions_xian"></div>
              </div>
              <div class="advance_title">商品发货</div>
              <div class="advance_time">预计{{ttshop_goodsxinxi.pre_detail.deliver_time_format}}</div>
            </div>
          </div>
        </div>
        <!-- end -->
        <!-- 热销模块 -->
        <div
          class="hot"
          v-if="
            ttshop_goodsxinxi.hot_goods_list &&
            ttshop_goodsxinxi.hot_goods_list.length
          "
        >
          <div class="hot-tab d-flex">
            <div class="tab-item hot_active">热销</div>
          </div>
          <div class="hot-swiper d-flex justify-content-between">
            <div class="hot-l swiper-button-prev">
              <img
                class="img-default"
                src="../../assets/images/img_left.png"
                alt
              />
            </div>
            <div class="img-list swiper-container d-flex">
              <div class="swiper-wrapper">
                <template
                  v-for="(item, index) in ttshop_goodsxinxi.hot_goods_list"
                >
                  <div
                    class="
                      swiper-slide
                      list-item
                      d-flex
                      flex-direction-column
                      justify-content-between
                    "
                    @click="toGoods(item.id)"
                  >
                    <div class="item-img">
                      <img class="img-default" :src="item.cover_pic" alt="" />
                    </div>
                    <div
                      class="item-name show-two-lines"
                      v-text="item.name"
                    ></div>
                    <!-- 价格面议 -->
                    <div class="item-pic" v-if="item.is_negotiable == 0">
                      ¥{{ item.price }}
                    </div>
                    <div class="item-pic" v-else>{{ item.price }}</div>
                  </div>
                </template>
              </div>
            </div>
            <div class="hot-r swiper-button-next">
              <img
                class="img-default"
                src="../../assets/images/img_right.png"
                alt
              />
            </div>
          </div>
        </div>
        <!-- 商品详情 -->
        <div class="details d-flex justify-content-between">
          <!-- 左边 -->
          <div class="details-l">
            <div class="shop" v-if="ttshop_goodsxinxi.mch">
              <div
                class="
                  shop-title
                  d-flex
                  justify-content-between
                  align-items-center
                "
              >
                <div class="title-l">商家</div>
                <div class="title-r d-flex align-items-center" v-if="false">
                  <div class="img-r">
                    <img
                      class="img-default"
                      src="../../assets/images/xcx.png"
                      alt
                    />
                  </div>
                  <div class="img-c">小程序店铺</div>
                  <div class="img-l">
                    <img
                      class="img-default"
                      src="../../assets/images/bottom_14.png"
                      alt
                    />
                  </div>
                </div>
              </div>
              <div
                class="shop-name show-one-lines"
                v-text="'商家：' + ttshop_goodsxinxi.mch.name"
              ></div>
              <div
                class="shop-tel show-one-lines"
                v-text="'电话：' + ttshop_goodsxinxi.mch.tel"
              ></div>
              <div
                class="shop-tel show-one-lines"
                v-text="'地址：' + ttshop_goodsxinxi.mch.address"
              ></div>
              <div class="shop-kf">
                联系：
                <ul class="d-flex flex-wrap justify-content-between">
                  <li
                    class="d-flex align-items-center"
                    v-if="customer_service"
                    @click="webService('mch')"
                  >
                    <img
                      class="img-default kf-img"
                      src="../../assets/images/service.png"
                      alt
                    />
                    在线客服
                  </li>
                  <template v-if="customer_list && customer_list.length">
                    <li
                      class="d-flex align-items-center"
                      v-for="(item, index) in customer_list"
                      @click="webServiceT(item.jump_url)"
                    >
                      <img class="img-default kf-img" :src="item.icon" alt />
                      {{ item.name }}
                    </li>
                  </template>
                </ul>
              </div>
              <div class="btn d-flex justify-content-between">
                <router-link
                  :to="{
                    path: '/shop',
                    query: { mch_id: ttshop_goodsxinxi.mch.id },
                  }"
                  class="btn-l d-flex justify-content-center align-items-center"
                >
                  进入店铺
                </router-link>
                <!-- <div>进入店铺</div> -->
                <div
                  class="btn-r d-flex justify-content-center align-items-center"
                  @click="shopFollowClick()"
                >
                  <template
                    v-if="ttshop_goodsxinxi.mch.is_follow == 0"
                    v-text=""
                    >关注店铺</template
                  >
                  <template v-else v-text="">已关注</template>
                </div>
              </div>
            </div>
            <div class="shop" v-else>
              <div
                class="
                  shop-title
                  d-flex
                  justify-content-between
                  align-items-center
                "
              >
                <div class="title-l">商家</div>
                <div class="title-r d-flex align-items-center" v-if="false">
                  <div class="img-r">
                    <img
                      class="img-default"
                      src="../../assets/images/xcx.png"
                      alt
                    />
                  </div>
                  <div class="img-c">小程序店铺</div>
                  <div class="img-l">
                    <img
                      class="img-default"
                      src="../../assets/images/bottom_14.png"
                      alt
                    />
                  </div>
                </div>
              </div>
              <div class="shop-name show-one-lines">商家：平台自营</div>
              <div class="shop-tel show-one-lines" v-if="contact_tel">
                电话：{{ contact_tel }}
              </div>
              <div class="shop-kf">
                联系：
                <ul class="d-flex flex-wrap justify-content-between">
                  <li
                    class="d-flex align-items-center"
                    v-if="
                      store_option.web_service_status == 1 &&
                      store_option.web_service_url
                    "
                    @click="webService()"
                  >
                    <img
                      class="img-default kf-img"
                      src="../../assets/images/service.png"
                      alt
                    />
                    在线客服
                  </li>
                  <template v-if="customer_list && customer_list.length">
                    <li
                      class="d-flex align-items-center"
                      v-for="(item, index) in customer_list"
                      @click="webServiceT(item.jump_url)"
                    >
                      <img class="img-default kf-img" :src="item.icon" alt />
                      {{ item.name }}
                    </li>
                  </template>
                </ul>
              </div>
              <div class="shop-tel show-one-lines"></div>
            </div>
            <div class="goods">
              <div class="goods-title">相关推荐</div>
              <div
                class="goods-list"
                v-if="
                  ttshop_goodsxinxi.cat_goods_list &&
                  ttshop_goodsxinxi.cat_goods_list.length
                "
              >
                <div
                  class="goods-item"
                  v-for="(item, index) in ttshop_goodsxinxi.cat_goods_list"
                  :key="index"
                  @click="toGoods(item.id)"
                >
                  <div class="item-img">
                    <img class="img-default" :src="item.cover_pic" alt="" />
                  </div>
                  <div class="item-name" v-text="item.name"></div>
                  <!-- 价格面议 -->
                  <div class="item-pic" v-if="item.is_negotiable == 0">
                    ¥{{ item.price }}
                  </div>
                  <div class="item-pic" v-else>{{ item.price }}</div>
                </div>
              </div>
              <template v-else>
                <div class="zntj" v-if="datatype">
                  <img
                    class="img-default"
                    src="../../assets/images/ttshop_zanwu.png"
                    alt=""
                  />
                  <p>暂无相关推荐</p>
                </div>
              </template>
            </div>
          </div>
          <!-- 右边 -->
          <div class="details-r">
            <div class="details-r-box">
              <div class="tab d-flex">
                <div
                  class="tab-item"
                  @click="detailsClick(0)"
                  :class="{ details_active: 0 == detailsIndex }"
                >
                  商品详情
                </div>
                <div
                  class="tab-item tab-itemeds"
                  @click="detailsClick(1)"
                  :class="{ details_active: 1 == detailsIndex }"
                >
                  商品评价（{{ evaluateTab.score_all }}）
                </div>
                <div
                  class="tab-item"
                  @click="detailsClick(2)"
                  :class="{ details_active: 2 == detailsIndex }"
                  v-if="ttshop_goodsxinxi.packing"
                >
                  包装清单
                </div>
                <div
                  class="tab-item"
                  @click="detailsClick(3)"
                  :class="{ details_active: 3 == detailsIndex }"
                  v-if="ttshop_goodsxinxi.after_sales"
                >
                  售后保障
                </div>
                <div class="mobile d-flex align-items-center" v-if="false">
                  <div class="mobile-l"></div>
                  <div class="mobile-c">手机购买</div>
                  <div class="mobile-r">
                    <img
                      class="img-default"
                      src="../../assets/images/bottom_14.png"
                      alt
                    />
                  </div>
                  <div class="mobile-hidden">
                    <div class="mobile-hidden-img"></div>
                  </div>
                </div>
                <template v-if="ttshop_goodsxinxi.status == 1">
                  <div
                    class="btn"
                    @click="goodsSubmit(1)"
                    v-if="ttshop_goodsxinxi.vr_type == 0"
                    style="margin-left: auto"
                  >
                    加入购物车
                  </div>
                </template>
                <template v-else>
                  <div
                    class="btn sold_out_detail"
                    v-if="ttshop_goodsxinxi.vr_type == 0"
                    style="margin-left: auto"
                  >
                    加入购物车
                  </div>
                </template>
              </div>
              <!-- 详情 -->
              <div class="conter" v-if="detailsIndex == 0">
                <div class="conter-img" v-html="ttshop_goodsxinxi.detail"></div>
              </div>
              <!-- 评价 -->
              <div class="evaluate" v-if="detailsIndex == 1">
                <div
                  class="evaluate-tab d-flex align-items-center"
                  v-if="evaluateTab.score_all != 0"
                >
                  <div class="evaluate-num">
                    <div class="num">
                      {{ ttshop_goodsxinxi.good_rate }}
                      <span>%</span>
                    </div>
                    <div class="txt">好评率</div>
                  </div>
                  <div class="tab-list d-flex">
                    <div
                      class="tab-item"
                      :class="{ tab_item_avtive: score == 0 }"
                      @click="scoreTab(0)"
                    >
                      全部({{ evaluateTab.score_all }})
                    </div>
                    <div
                      class="tab-item"
                      :class="{ tab_item_avtive: score == 3 }"
                      @click="scoreTab(3)"
                    >
                      好评({{ evaluateTab.score_3 }})
                    </div>
                    <div
                      class="tab-item"
                      :class="{ tab_item_avtive: score == 2 }"
                      @click="scoreTab(2)"
                    >
                      中评({{ evaluateTab.score_2 }})
                    </div>
                    <div
                      class="tab-item"
                      :class="{ tab_item_avtive: score == 1 }"
                      @click="scoreTab(1)"
                    >
                      差评({{ evaluateTab.score_1 }})
                    </div>
                    <div
                      class="tab-item"
                      :class="{ tab_item_avtive: score == 4 }"
                      @click="scoreTab(4)"
                    >
                      有图({{ evaluateTab.score_4 }})
                    </div>
                  </div>
                </div>
                <div
                  class="evaluate-item d-flex align-items-start"
                  v-for="(item, index) in evaluateList"
                  :key="index"
                  v-show="evaluateList != ''"
                >
                  <div class="user-l align-items-center d-flex">
                    <div class="user-img">
                      <img class="img-default" :src="item.avatar_url" alt="" />
                    </div>
                    <div class="user-name">{{ item.nickname }}</div>
                  </div>
                  <div class="evaluate-item-r">
                    <div class="star-list d-flex">
                      <div
                        class="star-img"
                        v-for="items in Number(item.score_star)"
                        :key="items"
                      >
                        <img
                          class="img-default"
                          src="../../assets/images/star.png"
                          alt
                        />
                      </div>
                    </div>
                    <p class="txt">{{ item.content }}</p>
                    <div
                      class="img-list d-flex"
                      v-if="item.pic_list && item.pic_list.length"
                    >
                      <div
                        class="img"
                        v-for="(items, idx) in item.pic_list"
                        :key="idx"
                      >
                        <img class="img-default" :src="items" alt="" />
                      </div>
                    </div>
                    <div class="time">
                      {{ item.addtime }}
                    </div>
                    <div class="Business_reply" v-if="item.reply_content">
                      <div class="shop_reply">商家回复:</div>
                      <div class="reply_content">{{ item.reply_content }}</div>
                    </div>
                  </div>
                </div>
                <div
                  class="
                    evaluate-item
                    d-flex
                    align-items-center
                    justify-content-center
                  "
                  v-show="evaluateList == ''"
                >
                  暂无评价
                </div>
              </div>
              <div
                class="conter"
                v-if="detailsIndex == 2 && ttshop_goodsxinxi.packing"
              >
                <div
                  class="conter-img"
                  v-html="ttshop_goodsxinxi.packing"
                ></div>
              </div>
              <div
                class="conter"
                v-if="detailsIndex == 3 && ttshop_goodsxinxi.after_sales"
              >
                <div
                  class="conter-img"
                  v-html="ttshop_goodsxinxi.after_sales"
                ></div>
              </div>
            </div>
            <div
              class="page d-flex justify-content-end"
              v-if="detailsIndex == 1"
            >
              <el-pagination
                background
                @current-change="handleCurrentChange"
                @prev-click="pages_perv"
                @next-click="page_next"
                :page-size="limit"
                layout="prev, pager, next"
                :total="Number(row_count)"
                :hide-on-single-page="singlePage"
              ></el-pagination>
            </div>
            <div
              class="ttshop_qitashop"
              v-if="
                ttshop_goodsxinxi.best_goods_list &&
                ttshop_goodsxinxi.best_goods_list.length
              "
            >
              <!-- 其他商品 -->
              <div class="rest-title">其他商品</div>
              <!-- 商品列表 -->
              <div class="rest-list d-flex flex-wrap">
                <template
                  v-for="(item, index) in ttshop_goodsxinxi.best_goods_list"
                >
                  <div
                    class="
                      rest-item
                      d-flex
                      justify-content-between
                      flex-direction-column
                    "
                    @click="toGoods(item.id)"
                  >
                    <div class="rest-img">
                      <img class="img-default" :src="item.cover_pic" alt="" />
                    </div>
                    <div class="rest-name" v-text="item.name"></div>
                    <div
                      class="
                        rest-pic
                        d-flex
                        justify-content-between
                        align-items-end
                      "
                    >
                      <div class="pic-l"><span>¥</span> {{ item.price }}</div>
                      <div class="pic-r" v-if="false">
                        <span>540+</span> 评价
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="优惠券" :visible.sync="dialogFormVisible">
      <div class="coupon-tab d-flex">
        <div
          class="coupon-tab-item"
          @click="couponTab(0)"
          :class="{ coupon_active: 0 == couponIndex }"
        >
          可领取优惠券
        </div>
        <div
          class="coupon-tab-item"
          @click="couponTab(1)"
          :class="{ coupon_active: 1 == couponIndex }"
        >
          已领取优惠券
        </div>
      </div>
    </el-dialog>
    <Foot></Foot>
    <sidebar
      ref="sidebars"
      @parentFn="childTreeFn"
      :goodsId="ttshop_goodsxinxi.id"
    ></sidebar>
    <el-dialog title="预售规则" :visible.sync="plant_wide">
      <div v-if="ttshop_goodsxinxi.pre_detail" class="bill_monad">
        <div v-html="ttshop_goodsxinxi.pre_detail.rule"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Header from "@/components/header/header";
import Foot from "@/components/foot/foot";
import searchShop from "@/components/search/searchShop";
import Nav from "@/components/nav/nav";
import sidebar from "@/components/sidebar/sidebar";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "./details.css";
import PicZoom from "vue-piczoom";
export default {
  components: {
    Header,
    Foot,
    searchShop,
    Nav,
    sidebar,
    PicZoom,
  },
  data() {
    return {
      num: 1, //购物车数量
      detailsIndex: 0,
      sizeIndex: 0,
      colorIndex: 0,
      couponIndex: 0,
      datatype: false,
      dialogTableVisible: false,
      dialogFormVisible: false,
      id: this.$route.query.id, //商品id
      ttshop_goodsxinxi: {
        pic_list: [],
        cover_pic: "",
        mch: {},
      }, //商品信息
      ttshop_kucun: [], //商品库存
      ttshop_kcnum: 1,
      errorImg:
        'this.src="' + require("../../assets/images/lodingsb.svg") + '"', //图片加载失败
      goods_attr_info: {},
      evaluateList: [],
      evaluateTab: [],
      score: 0,
      page: 1,
      limit: 5,
      page_count: "",
      row_count: "",
      singlePage: true,
      setList: "",
      video_show: false,
      autoplay: "",
      customer_service: null,
      store: {},
      contact_tel: "",
      store_option: {},
      customer_list: [],
      ttshop_catlist: [],

      time_num: {
        day: "8",
        hour: 23,
        minute: 23,
        second: 23,
      },
      plant_wide:false,
      mobile_img:'',
    };
  },
  created() {
    window.sessionStorage.setItem("alipay_type", ""); //清除支付宝支付状态
    this.shopgoodsapi();
    this.commentList();
    this.getStore();
    // this.getCustomerList();
  },
  mounted() {},
  watch: {
    $route(to, from) {
      //监听路由是否变化
      if (to.query.id != from.query.id) {
        this.id = to.query.id;
        this.shopgoodsapi();
        this.commentList();
        this.detailsIndex = 0;
      }
    },
  },
  methods: {
    // 二级分类
    sort(id) {
      if (this.id == id) {
        return false;
      }
      this.id = id;
      this.brand_id = "";
      this.keyword = "";
      this.$router.push({
        path: "/list",
        query: {
          id: id,
        },
      });
    },
    // 获取商城配置
    getStore() {
      this.$api
        .store({})
        .then((res) => {
          this.contact_tel = res.data.contact_tel;
          this.store_option = res.data.store.option;
          this.store = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取客服列表
    getCustomerList() {
      let params = {};
      if (this.ttshop_goodsxinxi.mch) {
        params.mch_id = this.ttshop_goodsxinxi.mch.id;
      }
      this.$api
        .getCustomerList(params)
        .then((res) => {
          this.customer_list = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 客服
    customerService() {
      let params = {
        mch_id: this.ttshop_goodsxinxi.mch.id,
      };
      this.$api
        .customerService(params)
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            this.customer_service = res.customer_service;
          }
        })
        .catch((err) => {
          this.common.message(this, err);
        });
    },
    // 平台客服
    webService(type) {
      let goods = this.ttshop_goodsxinxi;
      let store = this.store.store;
      let customer_service = this.customer_service;
      if (this.$store.state.user) {
        if (this.$store.state.user.token != "") {
          let url_str = this.common.webService(
            this,
            goods,
            store,
            type,
            customer_service
          );
          window.open(url_str);
        } else {
          this.$router.push({
            name: "signin",
            query: {
              redirect: this.$router.currentRoute.fullPath,
            },
          });
        }
      } else {
        this.$router.push({
          name: "signin",
          query: {
            redirect: this.$router.currentRoute.fullPath,
          },
        });
      }
    },
    // 外联客服
    webServiceT(url) {
      window.open(url);
    },
    // 弹出视频
    videoShow() {
      this.video_show = !this.video_show;
      this.autoplay = true;
    },
    // 套餐加入购物车
    setJoin(index) {
      let that = this;
      let goods_parts = that.setList[index];
      let attr_group = {};
      for (let i in goods_parts.goods_join) {
        let goods_id = goods_parts.goods_join[i].goods_id;
        let attr_list = goods_parts.goods_join[i].attr.attr_list;
        attr_group[goods_id] = [];
        for (let j in attr_list) {
          attr_group[goods_id].push({
            attr_group_id: attr_list[j].attr_group_id,
            attr_id: attr_list[j].attr_id,
          });
        }
      }
      let params = {
        part_id: goods_parts.goods_parts_id,
        attr: JSON.stringify(attr_group),
        num: 1,
      };
      this.$api
        .suitAddcart(params)
        .then((res) => {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "warning",
            offset: 200,
            duration: 1000,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    scoreTab(index) {
      if (this.score != index) {
        this.score = index;
      }
      this.page = 1;
      this.commentList();
    },
    childTreeFn() {
      this.$refs.searnum.cartnumapi();
    },
    shopgoodsapi() {
      let that = this;
      this.$loading();
      this.datatype = false;
      let data = {
        id: this.id,
      };
      this.$api
        .shopgoods(data)
        .then((res) => {
          if (res.code == 0) {
            that.$loading().close();
            if (res.data.pre_detail) {
              if (res.data.pre_detail.final_start_time) {
                res.data.pre_detail.deposit_start_time_format = that.gettime(
                  res.data.pre_detail.deposit_start_time
                )+'-'+that.gettime(res.data.pre_detail.deposit_end_time);
                res.data.pre_detail.final_end_time_format =that.gettime(res.data.pre_detail.final_start_time)+'-'+ that.gettime(
                  res.data.pre_detail.final_end_time
                );
                res.data.pre_detail.deliver_time_format=that.gettime(res.data.pre_detail.deliver_time)
              }
            }
            that.ttshop_goodsxinxi = res.data;
            console.log(that.ttshop_goodsxinxi)
            if (!that.ttshop_goodsxinxi.cover_pic && res.data.pic_list[0]) {
              that.ttshop_goodsxinxi.cover_pic = res.data.pic_list[0].pic_url;
            }
            that.ttshop_kucun = JSON.parse(res.data.attr);
            that.setList = res.data.goods_parts;
            that.datatype = true;
            that.ttshop_catlist = res.data.cat_list||[];
            if (res.data.pre_detail) {
              that.countdown(that);
            }
            setTimeout(function () {
              // 商品图片轮播
              new Swiper(".goods-img", {
                loop: false,
                slidesPerView: 5,
                spaceBetween: 8,
                observer: true,
                observeParents: true,
                navigation: {
                  nextEl: ".btn-r ",
                  prevEl: ".btn-l",
                },
              });
              // 看了又看
              new Swiper(".goods-look", {
                slidesPerView: 3,
                spaceBetween: 24,
                direction: "vertical",
                navigation: {
                  nextEl: ".btn-bottom",
                  prevEl: ".btn-top",
                },
              });
              // 热销
              new Swiper(".hot-swiper .img-list", {
                slidesPerView: 6,
                spaceBetween: 32,
                navigation: {
                  nextEl: ".hot-r",
                  prevEl: ".hot-l",
                },
              });
              for (let i in res.data.goods_parts) {
                let element = ".set" + i + " .set-item";
                let nextEl = ".set" + i + " .setbtn-r";
                let prevEl = ".set" + i + " .setbtn-l";
                let setswiper = new Swiper(element, {
                  loop: false,
                  // autoplay: true,
                  slidesPerView: 3,
                  spaceBetween: 48,
                  observer: true,
                  observeParents: true,
                  navigation: {
                    nextEl: nextEl,
                    prevEl: prevEl,
                  },
                });
              }
            }, 500);
            that.singleAttr();
            if (res.data.mch) {
              that.customerService();
            }
            that.getCustomerList();
            
            that.getqrcode();
          }
        })
        .catch((err) => {
          // let that = this;
          that.common.message(that, err, function () {
            setTimeout(() => {
              that.$router.go(-1);
            }, 1000);
          });
        });
    },
    getqrcode(){
      let that=this;
      let data={
        goods_id:this.id,
      }
      this.$api
        .good_qcode(data)
        .then((res) => {
          console.log(res)
          if(res.code==0){
            that.mobile_img=res.data.wx
          }
        }).catch((err)=>{
          console.log(err)
        })
    },
    // 预售
    gettime(time) {
      var date = new Date(time * 1000);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? "0" + minute : minute;
      second = second < 10 ? "0" + second : second;
      return  m + "月" + d + "日 " + h + ":" + minute;
    },
    countdown(that) {
      var NowTime = new Date().getTime();
      var EndTime =
        Number(this.ttshop_goodsxinxi.pre_detail.deposit_end_time) * 1000;
      var total_micro_second = EndTime - NowTime || [];
      // console.log('当前时间' + NowTime + '\n剩余时间：' + total_micro_second);
      let counttime = that.time_num;
      if (total_micro_second > 0) {
        counttime.day = that.dateformaDay(total_micro_second);
        counttime.hour = that.dateformaHour(total_micro_second);
        counttime.minute = that.dateformaMinute(total_micro_second);
        counttime.second = that.dateformaSecondMinute(total_micro_second);
      } else {
        counttime.day = 0;
        counttime.hour = 0;
        counttime.minute = 0;
        counttime.second = 0;
      }

      // 渲染倒计时时钟
      that.time_num = counttime;
      if (total_micro_second > 0) {
        setTimeout(function () {
          total_micro_second -= 1000;
          that.countdown(that);
        }, 1000);
      }
    },
    dateformaDay(micro_second) {
      // 总秒数
      var second = Math.floor(micro_second / 1000);
      // 天数
      var day = Math.floor(second / 3600 / 24);
      return day;
    },

    dateformaHour(micro_second) {
      // 总秒数
      var second = Math.floor(micro_second / 1000);
      // 小时
      var hr = Math.floor((second / 3600) % 24);
      if (hr < 10) {
        hr = "0" + hr;
      }
      return hr;
    },

    dateformaMinute(micro_second) {
      // 总秒数
      var second = Math.floor(micro_second / 1000);
      // 分钟
      var min = Math.floor((second / 60) % 60);
      if (min < 10) {
        min = "0" + min;
      }
      return min;
    },

    dateformaSecondMinute(micro_second) {
      // 总秒数
      var second = Math.floor(micro_second / 1000);
      // 秒
      var sec = Math.floor(second % 60);
      if (sec < 10) {
        sec = "0" + sec;
      }
      return sec;
    },
    // end
    // 评价预览
    commentList() {
      let data;
      if (this.score != 0) {
        data = {
          goods_id: this.id,
          score: this.score,
          page: this.page,
          limit: this.limit,
        };
      } else {
        data = {
          goods_id: this.id,
          page: this.page,
          limit: this.limit,
        };
      }
      this.$api
        .commentList(data)
        .then((res) => {
          this.evaluateList = res.data.list;
          this.evaluateTab = res.data.comment_count;
          this.page_count = res.data.page_count;
          this.row_count = res.data.row_count;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleCurrentChange(e) {
      this.page = e;
      this.common.backTop();
      this.commentList();
    },
    // 分页上一页
    pages_perv() {
      this.page--;
      this.common.backTop();
      this.commentList();
    },
    // 分页下一页
    page_next() {
      this.page++;
      this.common.backTop();
      this.commentList();
    },
    // 商品小图片移入事件
    enters(src) {
      this.ttshop_goodsxinxi.cover_pic = src;
    },

    handleChange(value) {
      this.num = value;
    },
    // 分类
    detailsClick(e) {
      this.detailsIndex = e;
    },
    // 单属性自动选择
    singleAttr() {
      let that = this;
      let attr_group_list = that.ttshop_goodsxinxi.attr_group_list;
      for (let i in attr_group_list) {
        for (let j in attr_group_list[i].attr_list) {
          that.$set(attr_group_list[i].attr_list[j], "active", false);
          that.$set(attr_group_list[i].attr_list[j], "attr_num_0", false);
        }
        if (attr_group_list[i].attr_list.length <= 1) {
          that.sizeClick(
            attr_group_list[i].attr_group_id,
            attr_group_list[i].attr_list[0].attr_id
          );
        }
      }
    },
    // 属性尺码
    sizeClick(groupid, attrid) {
      let attr_group = this.ttshop_goodsxinxi.attr_group_list; //商品总属性
      let attr_group_id = groupid; //属性组id
      let attr_id = attrid; //属性id
      let ativerattr = [];
      let attr = this.ttshop_kucun; //属性库存
      for (var i in attr_group) {
        if (attr_group[i].attr_group_id == attr_group_id) {
          for (var j in attr_group[i].attr_list) {
            // attr_group[i].attr_list[j].active =
            // attr_group[i].attr_list[j].attr_id == attr_id ? true : false;
            attr_group[i].attr_list[j].active =
              attr_group[i].attr_list[j].attr_id == attr_id
                ? !attr_group[i].attr_list[j].active
                : false;
          }
        }
      }
      for (var i in attr_group) {
        for (var j in attr_group[i].attr_list) {
          if (attr_group[i].attr_list[j].active) {
            ativerattr.push(attr_group[i].attr_list[j].attr_id);
          }
        }
      }
      var u = [],
        goods_attr_info = null;
      for (var n in attr) {
        var c = [],
          _ = 0;
        for (var d in attr[n].attr_list) {
          this.inArray(attr[n].attr_list[d].attr_id, ativerattr) || (_ += 1),
            c.push(attr[n].attr_list[d].attr_id);
        }
        0 === attr[n].num && _ <= 1 && u.push(c);
        if (ativerattr.toString() == c.toString()) {
          goods_attr_info = attr[n];
        }
      }
      var g = ativerattr.length,
        l = [];
      if (attr_group.length - g <= 1)
        for (var n in ativerattr)
          for (var d in u)
            if (this.inArray(ativerattr[n], u[d]))
              for (var f in u[d]) u[d][f] !== ativerattr[n] && l.push(u[d][f]);
      for (var n in attr_group)
        for (var d in attr_group[n].attr_list) {
          var m = attr_group[n].attr_list[d];
          this.inArray(m.attr_id, l) && !this.inArray(m.attr_id, ativerattr)
            ? (m.attr_num_0 = !0)
            : (m.attr_num_0 = !1);
        }

      this.check_attr_length = g;
      if (g == attr_group.length && goods_attr_info) {
        let goods_attr_name = "";
        for (let i in goods_attr_info.attr_list) {
          goods_attr_name += goods_attr_info.attr_list[i].attr_name + ";";
        }
        this.goods_attr_info = goods_attr_info;
        this.ttshop_kcnum = Number(goods_attr_info.num); //商品总库存
        this.goods_attr_name = goods_attr_name.substring(
          0,
          goods_attr_name.length - 1
        );
      // console.log(goods_attr_info)
        if(this.ttshop_goodsxinxi.pre_detail&&this.ttshop_goodsxinxi.use_attr==1){
          this.ttshop_goodsxinxi.pre_detail.deposit_price=goods_attr_info.deposit_price;
          this.ttshop_goodsxinxi.pre_detail.offset_price=goods_attr_info.offset_price;
          this.ttshop_goodsxinxi.pre_detail.pre_price=goods_attr_info.pre_price
        }
        if (goods_attr_info.pic) {
          this.ttshop_goodsxinxi.cover_pic = goods_attr_info.pic;
        }
      }
      this.$forceUpdate()
    },
    inArray: function (e, t) {
      return t.some(function (t) {
        return e === t;
      });
    },
    // 加入购物车和立即购买
    goodsSubmit(type) {
      let that=this;
      if (this.ttshop_goodsxinxi.is_negotiable == 1) {
        this.$message({
          showClose: true,
          message: "面议商品不可直接购买",
          type: "warning",
          offset: 200,
          duration: 1000,
        });
        return false;
      }
      //type = 1 加入购物车  type = 2 立即购买
      let attr_group = this.ttshop_goodsxinxi.attr_group_list;
      let goods_num = this.goods_attr_info.num; //选择商品的库存
      if (this.check_attr_length != attr_group.length) {
        this.$message({
          showClose: true,
          message: "请选择商品属性",
          type: "warning",
          offset: 200,
          duration: 1000,
        });
        return false;
      }
      let attr = [];
      for (let i in attr_group) {
        for (let j in attr_group[i].attr_list) {
          if (attr_group[i].attr_list[j].active) {
            attr.push({
              attr_group_id: attr_group[i].attr_group_id,
              attr_id: attr_group[i].attr_list[j].attr_id,
              attr_name: attr_group[i].attr_list[j].attr_name,
            });
          }
        }
      }
      if (goods_num < this.num) {
        this.$message({
          showClose: true,
          message: "商品库存不足",
          type: "warning",
          offset: 200,
          duration: 1000,
        });
        return false;
      }
      
    let date = Number(Date.parse(new Date())) / 1000;
    if(that.ttshop_goodsxinxi.pre_detail){
      if(Number(that.ttshop_goodsxinxi.pre_detail.deposit_start_time)>Number(date)){
        this.$message({
                showClose: true,
                message: '预售活动未开始',
                type: "error",
                offset: 200,
                duration: 1000,
              });
        return 
      }else if(Number(that.ttshop_goodsxinxi.pre_detail.deposit_end_time)<Number(date)){
        this.$message({
          showClose: true,
          message: '预售活动已结束',
          type: "error",
                offset: 200,
                duration: 1000,
        });
        return 
      }
    };
      if (type == 1) {
        let data = {
          goods_id: this.id,
          attr: JSON.stringify(attr),
          num: this.num,
        };
        this.$api
          .shopcar(data)
          .then((res) => {
            if (res.code == 0) {
              this.$message({
                showClose: true,
                message: res.msg,
                type: "success1",
                offset: 200,
                duration: 1000,
              });
              this.$refs.sidebars.shopcatapi();
              this.$refs.searnum.cartnumapi();
              this.$refs.sidebars.cartNum();
            }else{
              that.$message({
                showClose: true,
                message: res.msg,
                type: "error",
                offset: 200,
                duration: 1000,
              });
            }
          })
          .catch((err) => {
            console.log(err);
            that.$message({
                showClose: true,
                message: err.msg,
                type: "error",
                offset: 200,
                duration: 1000,
              });
          });
      } else if (type == 2) {
        let that = this;
        let mch_id = 0;
        let vr_type = 0;
        if (this.ttshop_goodsxinxi.type == 3) {
          mch_id = "alibaba";
        } else if (this.ttshop_goodsxinxi.type == 6) {
          mch_id = "jdvop";
        } else if (this.ttshop_goodsxinxi.type == 7) {
          mch_id = "yzh";
        } else {
          if (this.ttshop_goodsxinxi.mch) {
            mch_id = this.ttshop_goodsxinxi.mch.id;
          } else if (this.ttshop_goodsxinxi.mch_id) {
            mch_id = this.ttshop_goodsxinxi.mch_id;
          }
        }

        if (this.ttshop_goodsxinxi.vr_type >= 0) {
          vr_type = this.ttshop_goodsxinxi.vr_type;
        }
        let mch_list = [
          {
            mch_id: mch_id,
            goods_list: [
              {
                goods_id: this.id,
                attr: attr,
                num: this.num,
              },
            ],
          },
        ];
        
        
      if(that.ttshop_goodsxinxi.pre_detail){
        mch_list[0].goods_list[0].pag_id=that.ttshop_goodsxinxi.pre_detail.pag_id
      }
        if (this.$store.state.user) {
          if (this.$store.state.user.token != "") {
            let params = {
              mch_list: JSON.stringify(mch_list),
              vr_type: vr_type,
            };
            this.$store.commit("submitOrderRarams", params);
            this.$router.push({
              name: "submitOrder",
            });
          } else {
            this.$router.push({
              name: "signin",
              query: {
                redirect: this.$router.currentRoute.fullPath,
              },
            });
          }
        } else {
          this.$router.push({
            name: "signin",
            query: {
              redirect: this.$router.currentRoute.fullPath,
            },
          });
        }
      }
    },
    // 点击相关推荐
    toGoods(id) {
      /* this.goods_attr_name = ""; //选中属性名称
				this.goods_attr_info = {}; //选中的属性
				this.check_attr_length = 0; //选中属性长度
				this.goods_buy_num = 1; //购买数量 */
      let url = this.$router.resolve({
        path: "/pages/goods/goods",
        query: {
          id: id,
        },
      });
      window.open(url.href);
    },
    //颜色
    colorClick(index) {
      this.colorIndex = index;
    },
    //优惠券
    couponTab(index) {
      this.couponIndex = index;
    },
    // 收藏商品
    favoriteCilck() {
      this.$loading();
      let that = this;
      let params = {
        goods_id: that.ttshop_goodsxinxi.id,
      };
      if (that.ttshop_goodsxinxi.is_favorite == 0) {
        this.$api
          .favoriteAdd(params)
          .then((res) => {
            this.$loading().close();
            if (res.code == 0) {
              this.$message({
                showClose: true,
                message: "关注成功",
                type: "success",
                offset: 200,
                duration: 1000,
              });
              that.ttshop_goodsxinxi.is_favorite = 1;
            }
          })
          .catch((err) => {
            this.common.message(this, err);
          });
      } else {
        this.$api
          .favoriteRemove(params)
          .then((res) => {
            this.$loading().close();
            if (res.code == 0) {
              this.$message({
                showClose: true,
                message: "已取消关注",
                type: "success",
                offset: 200,
                duration: 1000,
              });
              that.ttshop_goodsxinxi.is_favorite = 0;
            }
          })
          .catch((err) => {
            this.common.message(this, err);
          });
      }
    },
    // 关注店铺
    shopFollowClick() {
      this.$loading();
      let that = this;
      let params = {
        mch_id: that.ttshop_goodsxinxi.mch.id,
      };
      if (that.ttshop_goodsxinxi.mch.is_follow == 0) {
        this.$api
          .shopFollow(params)
          .then((res) => {
            this.$loading().close();
            if (res.code == 0) {
              this.$message({
                showClose: true,
                message: "关注成功",
                type: "success",
                offset: 200,
                duration: 1000,
              });
              that.ttshop_goodsxinxi.mch.is_follow = 1;
            }
          })
          .catch((err) => {
            console.log(err);
            this.common.message(this, err);
          });
      } else {
        this.$api
          .shopUnFollow(params)
          .then((res) => {
            this.$loading().close();
            if (res.code == 0) {
              this.$message({
                showClose: true,
                message: "已取消关注",
                type: "success",
                offset: 200,
                duration: 1000,
              });
              that.ttshop_goodsxinxi.mch.is_follow = 0;
            }
          })
          .catch((err) => {
            console.log(err);
            this.common.message(this, err);
          });
      }
    },
    // 预售规则
    flow_scheme(){
      this.plant_wide=true;
    },
  },
};
</script>

<style lang="scss" scoped>
.details_active {
  border-top: 2px solid #ff0e25;
  background-color: #fff;
  color: #ff0e25;
}

.hot_active {
  border-top: 2px solid #ff0e25;
  background-color: #fff;
  color: #ff0e25;
}

.size_active {
  border-color: #ff0e25 !important;
}

.coupon_active {
  border-color: #ff0e25 !important;
  color: #ff0e25 !important;
}

.bannershoper {
  width: 100%;
  height: 120px;
  background-color: #ccc;
}

// 面包屑
.crumb {
  width: 100%;
  height: 40px;
  background-color: #fafafa;

  .nav {
    height: 40px;

    .nav-item {
      color: #999999;
    }

    .nav-img {
      height: 12px;
      width: 12px;
    }

    .nav-items {
      height: 24px;
      position: relative;
      overflow: hidden;
      background-color: #fff;
      transition: 0.3s;

      &:hover {
        overflow: visible;

        dt {
          border-color: #ff0e25;
          border-bottom-color: #fff;
          z-index: 41;
          border-radius: 3px 3px 0 0;
        }

        dd {
          z-index: 40;
          border: 1px solid #ff0e25;
        }
      }

      dt {
        padding: 0px 4px 0px 8px;
        // line-height: 22px;
        height: 24px;
        border: 1px solid #ebebeb;
        position: relative;
        box-sizing: border-box;
        border-radius: 3px;
        background-color: #fff;
        z-index: 200;
      }

      .nav-xia {
        height: 12px;
        width: 12px;
        margin-left: 8px;
      }

      dd {
        width: 304px;
        padding: 6px 8px 10px 10px;
        position: absolute;
        top: 23px;
        left: 0;
        background-color: #fff;
        line-height: 24px;

        div {
          width: 96px;
        }
      }
    }

    .nav-option {
      padding: 0px 4px 0px 8px;
      height: 24px;
      border: 1px solid #ebebeb;
      box-sizing: border-box;
      border-radius: 3px;
      border: 1px solid #ebebeb;
      background-color: #fafafa;
      margin-right: 8px;

      span {
        color: #ff0e25;
      }

      .nav-del {
        height: 12px;
        width: 12px;
        margin-left: 8px;
      }
    }
  }
}

.content {
  // margin-top: 24px; //原来的
  margin-top: 14px;
}

// 商品属性
.goods {
  .zntj {
    width: 100%;
    padding: 40px 10px;
    box-sizing: border-box;

    img {
      display: block;
      width: 93px;
      height: 80px;
      margin: 0 auto 20px;
    }

    p {
      font-size: 14px;
      color: #333;
      text-align: center;
    }
  }

  .goods-l {
    width: 408px;
    .img {
      position: relative;
      height: 408px;
      width: 408px;
      .video-btn {
        cursor: pointer;
        width: 50px;
        height: 50px;
        position: absolute;
        bottom: 50px;
        left: 50%;
        margin-left: -25px;
        background-image: url("../../assets/images/main_circles.png");
        z-index: 1;
        border-radius: 50%;
      }
      .video-btn:hover {
        background-position: 50px 0;
      }
      .goods-video {
        outline: none;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        width: 100%;
        height: 100%;
        background: #000;
      }
      .video-close {
        cursor: pointer;
        position: absolute;
        z-index: 3;
        font-size: 18px;
        color: #ccc;
        top: 10px;
        right: 15px;
      }
    }

    .img-list {
      width: 408px;
      margin-top: 12px;
      height: 60px;
      padding: 0 38px;
      box-sizing: border-box;
      position: relative;

      .btn-l {
        width: 12px;
        height: 20px;
        background-image: none;
        right: 9px;
        outline: none;
        margin-top: -10px;
      }

      .goods-img {
        width: 408px;
        height: 60px;

        .img-item {
          height: 60px;
          width: 60px !important;
          border: 2px solid transparent;
          box-sizing: border-box;
          margin-right: 8px;
          cursor: pointer;

          img {
            width: 56px;
            height: 56px;
            object-fit: cover;
            display: block;
          }

          &:hover {
            border-color: #ff0e25;
          }
        }
      }

      .btn-r {
        width: 12px;
        height: 20px;
        background-image: none;
        right: 9px;
        outline: none;
        margin-top: -10px;
      }
    }

    .goods-l-btn {
      margin-top: 28px;

      .item {
        cursor: pointer;
        color: #666666;
        margin-right: 20px;

        i {
          font-size: 16px;
          margin-right: 2px;
        }

        .item-img {
          width: 12px;
          height: 12px;
          background: rgba(204, 204, 204, 1);
          margin-right: 4px;
        }
      }
    }
  }

  .goods-c {
    width: 550px;
    padding-bottom: 57px;
    box-sizing: border-box;

    .name {
      font-size: 16px;
      font-weight: 600;
    }

    .name-item {
      margin-top: 8px;
      font-size: 14px;
      color: #ff0e25;
    }

    .pic {
      width: 550px;
      height: 94px;
      background: #fafafa;
      margin-top: 24px;
      padding-left: 12px;
      border: 1px solid transparent;
      box-sizing: border-box;

      .pic-top {
        margin-top: 16px;
        color: #666666;

        del {
          margin-left: 36px;
          color: #666666;
          text-decoration: line-through;
        }
        span{
          margin-left: 24px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 12px;
        }
      }

      .pic-bottom {
        color: #666666;
        margin-top: 12px;

        :first-child {
          font-size: 16px;
          color: #ff4300;
          font-weight: bold;
          margin-left: 32px;
        }
        :nth-child(2){
          font-size: 30px;
          color: #ff4300;
          font-weight: bold;
          margin-left: 4px;
        }
        :last-child {
          font-size: 30px;
          color: #ff4300;
          font-weight: bold;
          margin-left: 4px;
        }
        .deduction{
          padding: 2px;
          border-radius: 3px;
          border: 1px solid #FF0E25;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FF0E25;
          line-height: 12px;
          margin-left: 10px;
        }
      }
      .pre_pic_bottom{
        display: flex;
        align-items: flex-end;
      }
    }

    // 优惠券
    .coupon {
      margin-top: 20px;

      .coupon-name {
        width: 76px;
        color: #666666;
        padding-left: 12px;
        box-sizing: border-box;
      }

      .coupon-list {
        .item {
          height: 20px;
          margin-right: 8px;
          cursor: pointer;

          .item-l {
            width: 32px;
            background-image: url(../../assets/images/coupon_item.png);
            background-repeat: no-repeat;
            color: #fff;
          }

          .item-r {
            width: 68px;
            background-color: #fff0f1;
            color: #ff0e25;
          }
        }
      }

      .coupon-btn {
        font-size: 12px;
        color: #0e9cff;
        cursor: pointer;
      }
    }

    // 促销
    .rush {
      margin-top: 16px;

      .rush-name {
        width: 76px;
        color: #666666;
        padding-left: 12px;
        box-sizing: border-box;
        margin-bottom: 6px;
      }

      .rush-list {
        .item {
          min-width: 40px;
          height: 20px;
          border-radius: 2px;
          border: 1px solid #ff0e25;
          color: #ff0e25;
          margin: 0 8px 6px 0;
          padding: 0 8px;
          box-sizing: border-box;
        }
      }
    }

    //数据展示
    .shownum {
      height: 36px;
      width: 550px;
      border-top: 1px dashed #e6e6e6;
      border-bottom: 1px dashed #e6e6e6;
      margin-top: 24px;

      .shownum-item {
        width: 33%;
        color: #999999;

        + .shownum-item {
          border-left: 1px solid #e6e6e6;
        }

        span {
          font-weight: bold;
          color: #ff0e25;
          margin-left: 4px;
        }
      }
    }

    // 尺码
    .size {
      margin-top: 16px;

      .size-name {
        width: 76px;
        color: #666666;
        padding-left: 12px;
        box-sizing: border-box;
      }

      .size-list {
        .items {
          cursor: no-drop;
          min-width: 35px;
          height: 34px;
          border-radius: 2px;
          border: 1px dashed #ccc;
          margin-right: 8px;
          padding: 0 12px;
          box-sizing: border-box;
          position: relative;
          margin-bottom: 5px;
          opacity: 0.8;
        }

        .item {
          cursor: pointer;
          min-width: 35px;
          height: 34px;
          border-radius: 2px;
          border: 1px solid #ebebeb;
          margin-right: 8px;
          padding: 0 12px;
          box-sizing: border-box;
          position: relative;
          margin-bottom: 5px;

          .pitc {
            position: absolute;
            bottom: 0;
            right: 0;
            height: 12px;
            width: 12px;
          }

          &:hover {
            border-color: #ff0e25;
          }
        }
      }
    }

    //颜色
    .color {
      margin-top: 16px;

      .color-name {
        width: 76px;
        color: #666666;
        padding-left: 12px;
        box-sizing: border-box;
      }

      .color-list {
        position: relative;
        height: 34px;

        .item {
          // position: relative;
          .item-txt {
            cursor: pointer;
            min-width: 64px;
            height: 34px;
            border-radius: 2px;
            border: 1px solid #ebebeb;
            margin-right: 8px;
            padding: 0 12px;
            box-sizing: border-box;
            background: #fff;
          }

          &:hover {
            .item-txt {
              border-color: #ff0e25;
              border-bottom-color: #fff;
              z-index: 5000;
            }

            .set {
              // display: block;
              visibility: initial;
            }
          }

          .set {
            // display: none;
            visibility: hidden;
            height: 216px;
            width: 478px;
            background: #fff;
            position: absolute;
            top: 33px;
            left: 0;
            z-index: 100;
            border: 1px solid #ff0e25;
            border-radius: 0px 2px 2px 2px;
            padding: 20px 48px 0px 48px;
            box-sizing: border-box;

            .setbtn-l {
              width: 12px;
              height: 20px;
              outline: none;
              cursor: pointer;
              left: 12px;
              top: 82px;
              background-image: none;
            }

            .setbtn-r {
              cursor: pointer;
              width: 12px;
              height: 20px;
              outline: none;
              right: 12px;
              top: 82px;
              background-image: none;
            }

            .setlist {
              overflow: hidden;

              .set-item {
                height: 134px;

                .setitem {
                  width: 90px;
                  position: relative;

                  // margin-right: 56px;
                  .setitem-img {
                    width: 90px;
                    height: 90px;
                  }

                  .setitem-name {
                    color: #666666;
                    line-height: 18px;
                    height: 36px;
                    overflow: hidden;
                    margin-top: 8px;
                  }

                  &::before {
                    content: "";
                    height: 24px;
                    width: 24px;
                    background-image: url(../../assets/images/set_jia.png);
                    background-repeat: no-repeat;
                    position: absolute;
                    top: 38px;
                    right: -40px;
                  }

                  // &:last-child::before {
                  //   display: none;
                  // }
                }
              }
            }

            .setbottom {
              height: 44px;
              border-top: 2px dashed #ccc;

              .setbottom-l {
                color: #999999;

                span {
                  font-size: 16px;
                  font-weight: bold;
                  color: #ff4300;
                }
              }

              .setbottom-btn {
                width: 72px;
                height: 28px;
                background: #ff0e25;
                border-radius: 2px;
                color: #ffffff;
                cursor: pointer;
              }
            }
          }
        }
      }
    }

    // 数量
    .num {
      margin-top: 16px;

      .num-name {
        width: 76px;
        color: #666666;
        padding-left: 12px;
        box-sizing: border-box;
      }
    }

    // 按钮
    .btn {
      margin-top: 24px;
      margin-left: 76px;

      .btn-buy {
        cursor: pointer;
        width: 112px;
        height: 40px;
        background: #ff0e25;
        border-radius: 2px;
        color: #fff;
        font-size: 16px;
        font-weight: 500;
      }

      .btn-cat {
        cursor: pointer;
        margin-left: 8px;
        width: 148px;
        height: 40px;
        background: rgba(255, 144, 16, 1);
        border-radius: 2px;
        font-weight: 500;
        font-size: 16px;
        color: #fff;

        .btn-cat-img {
          height: 16px;
          width: 16px;
          margin-right: 4px;
        }
      }

      .btn-phone {
        margin-left: 8px;
        // width: 126px;
        height: 40px;
        border: 1px solid #ebebeb;
        border-radius: 2px;
        font-weight: 500;
        // font-size: 12px;
        color: #666666;
        position: relative;
        box-sizing: border-box;
        overflow: hidden;
        cursor: pointer;
        font-size: 16px;
        width: 164px;

        &:hover {
          overflow: visible;
        }

        .btn-phone-l {
          height: 16px;
          width: 16px;
          background-color: #cccccc;
          margin-right: 8px;
        }

        .btn-phone-r {
          height: 14px;
          width: 14px;
          margin-left: 20px;
        }

        .btn-phone-qr {
          // width: 126px;
          // height: 114px;
          border: 1px solid #ebebeb;
          background-color: #fff;
          position: absolute;
          left: -1px;
          top: 38px;
          box-sizing: border-box;
          padding: 0 12px;
          border-top-color: #fff;
          width: 164px;
          height: 139px;

          .btn-phone-img {
            // height: 102px;
            // width: 102px;
            // background-color: #ccc;
            width: 100%;
            height: 100%;
            img{
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }

  .goods-r {
    width: 199px;
    height: 571px;
    padding-bottom: 55px;
    padding-left: 35px;
    box-sizing: border-box;
    border-left: 1px solid #ebebeb;
    position: relative;
    border-bottom: 1px solid transparent;

    .title {
      color: #666666;
      margin-top: 12px;

      .txt {
        margin: 0 8px;
      }

      span {
        width: 38px;
        height: 1px;
        background: #ebebeb;
        display: inline-block;
      }
    }

    .list {
      height: 468px;
      margin-top: 24px;
      overflow: hidden;

      .item {
        cursor: pointer;
        height: 140px;
        width: 140px;
        position: relative;
        margin-bottom: 24px;
      }

      .pic {
        width: 140px;
        height: 24px;
        position: absolute;
        bottom: 0;
        left: 0;
        background: #fff;
        opacity: 0.8;
      }
    }

    .btn {
      width: 140px;
      margin-top: 24px;

      .btn-top {
        height: 20px;
        width: 12px;
        margin-right: 16px;
        background-image: none;
        left: 77px;
        outline: none;
        top: 100%;
        transform: rotate(90deg);
        -ms-transform: rotate(90deg);
        -moz-transform: rotate(90deg);
        -webkit-transform: rotate(90deg);
        -o-transform: rotate(90deg);
      }

      .btn-bottom {
        height: 20px;
        width: 12px;
        background-image: none;
        right: 66px;
        outline: none;
        top: 100%;
        transform: rotate(-90deg);
        -ms-transform: rotate(-90deg);
        -moz-transform: rotate(-90deg);
        -webkit-transform: rotate(-90deg);
        -o-transform: rotate(-90deg);
      }
    }
  }
}

//热销模块
.hot {
  width: 100%;
  border: 1px solid #ebebeb;
  box-sizing: border-box;

  .hot-tab {
    height: 32px;
    background-color: #fafafa;

    .tab-item {
      cursor: pointer;
      text-align: center;
      min-width: 100px;
      height: 32px;
      line-height: 32px;
      padding: 0 26px;
      box-sizing: border-box;
      font-size: 16px;
    }
  }

  .hot-swiper {
    padding: 32px;
    box-sizing: border-box;
    position: relative;

    .hot-l {
      // margin-top: 65px;
      width: 12px;
      height: 20px;
      background-image: none;
      left: 32px;
      outline: none;
      top: 127px;
    }

    .img-list {
      width: 1060px;
      overflow: hidden;

      .list-item {
        cursor: pointer;
        height: 222px;

        .item-img {
          width: 150px;
          height: 150px;
          background: #ccc;
        }

        .item-name:hover {
          color: #ff4300;
        }

        .item-pic {
          font-size: 16px;
          color: #ff4300;
          font-weight: bold;
        }
      }
    }

    .hot-r {
      width: 12px;
      height: 20px;
      background-image: none;
      right: 32px;
      outline: none;
      top: 127px;
    }
  }
}

// 商品详情
.details {
  margin-top: 21px;

  .details-l {
    width: 190px;

    .shop {
      width: 190px;
      border: 1px solid #ebebeb;
      box-sizing: border-box;

      .shop-title {
        height: 32px;
        width: 100%;
        background-color: #fafafa;
        padding: 0 12px;
        box-sizing: border-box;

        .title-l {
          font-size: 14px;
          color: #666666;
        }

        .title-r {
          .img-l {
            height: 12px;
            width: 12px;
          }

          .img-c {
            color: #666666;
            margin: 0 4px;
          }

          .img-r {
            height: 14px;
            width: 14px;
          }
        }
      }

      .shop-name {
        padding: 0 12px;
        box-sizing: border-box;
        margin-top: 24px;
        color: #666666;
      }

      .shop-tel {
        padding: 0 12px;
        box-sizing: border-box;
        margin-top: 16px;
        color: #666666;
      }

      .shop-kf {
        cursor: pointer;
        padding: 0 12px;
        box-sizing: border-box;
        margin-top: 16px;
        color: #666666;
        li {
          margin-top: 8px;
          margin-right: 8px;
        }
        .kf-img {
          height: 12px;
          width: 12px;
          margin-right: 4px;
        }
      }

      .btn {
        padding: 0 12px;
        box-sizing: border-box;
        margin: 24px 0 10px;

        .btn-l {
          width: 75px;
          height: 28px;
          border-radius: 2px;
          border: 1px solid #ff0e25;
          box-sizing: border-box;
          color: #ff0e25;
          outline: none;
          cursor: pointer;
        }

        .btn-r {
          width: 75px;
          height: 28px;
          border-radius: 2px;
          border: 1px solid #ff9010;
          box-sizing: border-box;
          color: #ff9010;
          outline: none;
          cursor: pointer;
        }
      }
    }

    .goods {
      margin-top: 17px;
      border: 1px solid #ebebeb;
      box-sizing: border-box;

      .goods-title {
        height: 32px;
        background-color: #fafafa;
        font-size: 14px;
        color: #666666;
        padding-left: 12px;
        box-sizing: border-box;
        line-height: 32px;
      }

      .goods-list {
        padding: 20px 25px 0 25px;
        box-sizing: border-box;

        .goods-item {
          margin-bottom: 20px;
          cursor: pointer;

          .item-img {
            height: 140px;
            width: 140px;
            background-color: #cccccc;

            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .item-name {
            line-height: 18px;
            height: 36px;
            overflow: hidden;
            color: #666666;
            margin-top: 16px;
            transition: 0.5s;
            -moz-transition: 0.5s;
            -webkit-transition: 0.5s;
            -o-transition: 0.5s;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }

          .item-pic {
            margin-top: 12px;
            color: #ff4300;
          }

          &:hover .item-name {
            color: #ff0e25;
          }
        }
      }
    }
  }

  .details-r {
    width: 990px;

    .details-r-box {
      width: 100%;
      // padding-bottom: 50px;
      border: 1px solid #ebebeb;
      box-sizing: border-box;

      .tab {
        height: 46px;
        background-color: #fafafa;

        .tab-item {
          height: 46px;
          padding: 0 24px;
          line-height: 46px;
          box-sizing: border-box;
          cursor: pointer;
          font-size: 16px;
        }

        .tab-active {
          background-color: #fff;
          border-top: 2px solid #ff0e25;
        }

        .mobile {
          height: 46px;
          box-sizing: border-box;
          width: 118px;
          margin-left: auto;
          box-sizing: border-box;
          border: 1px solid transparent;
          padding: 0 12px;
          overflow: hidden;
          position: relative;

          &:hover {
            overflow: visible;
            border-color: #ebebeb;
            background-color: #fff;
          }

          .mobile-l {
            height: 16px;
            width: 16px;
            background-color: #ccc;
          }

          .mobile-c {
            margin: 0 7px;
            color: #666666;
          }

          .mobile-r {
            height: 14px;
            width: 14px;
          }

          .mobile-hidden {
            width: 118px;
            height: 104px;
            position: absolute;
            left: -1px;
            top: 44px;
            border: 1px solid #ebebeb;
            border-top-color: #fff;
            background-color: #fff;
            padding: 0 12px;
            box-sizing: border-box;

            .mobile-hidden-img {
              width: 94px;
              height: 94px;
              background-color: #cccccc;
            }
          }
        }

        .btn {
          cursor: pointer;
          width: 126px;
          height: 46px;
          background: #ff9010;
          font-weight: 500;
          font-size: 16px;
          color: #fff;
          line-height: 46px;
          text-align: center;
          // margin-left: auto;
          margin-left: 12px;
        }
      }

      // 详情
      .conter {
        padding: 0 24px;
        box-sizing: border-box;

        .parameter {
          padding: 32px 0;
          box-sizing: border-box;
          border-bottom: 1px dashed #e6e6e6;

          .parameter-title {
            color: #666666;
            font-weight: 600;
          }

          .parameter-list {
            margin-top: 16px;

            .parameter-item {
              width: 240px;
              display: inline-block;
              color: #666666;
              margin-bottom: 4px;
            }
          }
        }

        .conter-img {
          width: 800px;
          margin: 0 auto;
          margin-top: 40px;
          margin-bottom: 50px;
        }
      }

      //评价
      .evaluate {
        padding: 0 24px;
        box-sizing: border-box;

        .evaluate-tab {
          height: 142px;
          padding: 0 24px;
          border-bottom: 1px dashed #e6e6e6;
          box-sizing: border-box;

          .evaluate-num {
            .num {
              font-size: 40px;
              font-weight: bold;
              color: #ff4300;

              span {
                font-size: 20px;
                color: #ff4300;
              }
            }

            .txt {
              font-size: 14px;
              color: #666666;
              margin-top: 5px;
            }
          }

          .tab-list {
            margin-left: 64px;

            .tab-item {
              padding: 0 24px;
              min-width: 100px;
              height: 32px;
              background: #fff0f1;
              border-radius: 16px;
              border: 1px solid #ff3346;
              font-size: 14px;
              color: #ff4300;
              text-align: center;
              line-height: 32px;
              box-sizing: border-box;
              margin-right: 16px;
              cursor: pointer;
            }

            .tab_item_avtive {
              background-color: #ff0e25;
              border: 0 none;
              color: #fff;
            }
          }
        }

        .evaluate-item {
          padding: 24px 0;
          box-sizing: border-box;
          border-bottom: 1px solid #ebebeb;

          &:last-child {
            border: 0;
          }

          .user-l {
            width: 199px;

            .user-img {
              width: 40px;
              height: 40px;
              border-radius: 40px;
            }

            .user-name {
              color: #999999;
              margin-left: 14px;
            }
          }

          .evaluate-item-r {
            .star-list {
              .star-img {
                height: 14px;
                width: 14px;
                margin-right: 2px;
              }
            }

            .txt {
              width: 742px;
              margin-top: 9px;
              line-height: 18px;
            }

            .img-list {
              margin-top: 16px;

              .img {
                width: 60px;
                height: 60px;
                margin-right: 4px;
                // background-color: #cccccc;
              }
            }

            .time {
              margin-top: 8px;
              color: #999999;
            }
          }
        }
      }
    }

    .details-r-box:last-child {
      margin-bottom: 42px;
    }

    .page {
      // margin-left: auto;
      margin-top: 25px;
    }

    // 其他商品
    .rest-title {
      width: 990px;
      height: 32px;
      background-color: #fafafa;
      line-height: 32px;
      padding-left: 26px;
      box-sizing: border-box;
      margin-top: 42px;
    }

    //商品列表
    .rest-list {
      width: 990px;
      margin-top: 16px;

      .rest-item {
        width: 246px;
        height: 334px;
        background-color: #ffffff;
        padding: 16px 12px;
        box-sizing: border-box;
        margin-bottom: 20px;
        margin-right: 2px;
        cursor: pointer;

        &:hover {
          box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
        }

        &:nth-child(4n) {
          margin-right: 0;
        }

        .rest-img {
          height: 222px;
          width: 222px;
          background-color: #cccccc;
        }

        .rest-name {
          height: 36px;
          color: #666666;
          overflow: hidden;
          line-height: 18px;
        }

        .rest-pic {
          .pic-l {
            font-weight: bold;
            font-size: 20px;
            color: #ff4300;

            span {
              font-size: 16px;
              color: #ff4300;
            }
          }

          .pic-r {
            color: #999999;

            span {
              color: #0e9cff;
              margin-right: 4px;
            }
          }
        }
      }
    }
  }
}

//优惠券弹窗
.coupon-tab {
  font-size: 32px;

  .coupon-tab-item {
    color: #666666;
    padding-bottom: 8px;
    box-sizing: border-box;
    border-bottom: 2px solid transparent;
    margin-right: 26px;
    cursor: pointer;
  }
}
.Business_reply {
  display: flex;
  align-items: flex-start;
  font-size: 14px;
  margin-top: 5px;
}
.shop_reply {
  color: #ff253a;
}
.reply_content {
  margin-left: 10px;
  font-weight: bold;
  color: #000;
  flex: 1;
}
.sold_out {
  background: #f2f2f2 !important;
  color: #5e5e5e !important;
}
.sold_out_detail {
  background: #f2f2f2 !important;
  color: #5e5e5e !important;
}
//面包屑
.nav {
  height: 56px;
  border-bottom: 1px solid #ebebeb;

  .nav-item {
    color: #999999;

    a {
      color: #999;
      transition: 0.5s;
      -moz-transition: 0.5s;
      -webkit-transition: 0.5s;
      -o-transition: 0.5s;

      &:hover {
        color: #ff0e25;
      }
    }
  }

  .nav-img {
    height: 12px;
    width: 12px;
  }
  .nav-items {
    height: 24px;
    position: relative;
    overflow: hidden;
    background-color: #fff;
    transition: 0.3s;

    &:hover {
      overflow: visible;

      dt {
        border-color: #ff0e25;
        border-bottom-color: #fff;
        z-index: 41;
        border-radius: 3px 3px 0 0;

        div {
          color: #ff0e25;
        }
      }

      dd {
        z-index: 40;
        border: 1px solid #ff0e25;
      }
    }
    &:hover ~ .nav-items dt {
      // border-bottom-color: #ff0e25;
      z-index: 1;
    }

    dt {
      padding: 0px 4px 0px 8px;
      // line-height: 22px;
      height: 24px;
      border: 1px solid #ebebeb;
      position: relative;
      box-sizing: border-box;
      border-radius: 3px;
      background-color: #fff;
      z-index: 200;
    }

    .nav-xia {
      height: 12px;
      width: 12px;
      margin-left: 8px;
    }

    dd {
      width: 304px;
      padding: 6px 8px 10px 10px;
      position: absolute;
      top: 23px; //原来的
      left: 0;
      background-color: #fff;
      line-height: 24px;

      div {
        // width: 96px;
        margin-right: 14px;
        cursor: pointer;
        transition: 0.5s;
        -moz-transition: 0.5s;
        -webkit-transition: 0.5s;
        -o-transition: 0.5s;

        &:hover {
          color: #ff0e25;
        }
      }

      div:last-child {
        margin-right: 0;
      }
    }
  }

  .nav-option {
    padding: 0px 4px 0px 8px;
    height: 24px;
    border: 1px solid #ebebeb;
    box-sizing: border-box;
    border-radius: 3px;
    border: 1px solid #ebebeb;
    background-color: #fafafa;
    margin-right: 8px;

    span {
      color: #ff0e25;
    }

    .nav-del {
      height: 12px;
      width: 12px;
      margin-left: 8px;
      cursor: pointer;
    }
  }
}
// 预售
.advance {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 12px;
  padding-right: 20px;
  padding-top: 8px;
  padding-bottom: 8px;
  background: #e62e34;
  margin-top: 24px;
  .advance_time {
    display: flex;
    align-items: center;
    .time_title {
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 12px;
      padding-right: 5px;
    }
    .time_date {
      margin-left: 4px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffea00;
      line-height: 12px;
      display: flex;
      align-items: center;
      p{
        
        color: #ffea00;
      }
    }
  }
  .advance_book {
    display: flex;
    align-items: center;
    .reservation {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 12px;
      span {
        color: #ffea00;
      }
    }
    .regulation {
      display: flex;
      align-items: center;
      margin-left: 24px;
      img {
        width: 16px;
        height: 16px;
      }
      p {
        margin-left: 4px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 12px;
      }
    }
  }
}
.presell{
  width: 100%;
  height: 82px;
  background: #FAFAFA;
  display: flex;
  align-items: center;
  margin-bottom: 21px;
  .presell_left{
    width: 290px;
    height: 82px;
    background: linear-gradient(90deg, #FFEFD1 0%, #FDC686 100%);
    display: flex;
    align-items: center;
    img{
      width:125px;
      height: 82px;
    }
    p{
      height: 82px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 28px;
      // margin-left: 20px;
      flex: 1;
    }
    .pre_triangle{
      width: 35px;
      height: 82px;
      background: #FAFAFA;
      margin-left: 24px;
      .triangle_left{
        width: 0px;
        height: 0px;
        border-left: 35px #FDC88A  solid;
        // border-top: 10px red solid;
        border-top: 41px transparent solid;
        border-bottom: 41px transparent solid;
        // border-bottom: 35px transparent solid;
      }
    }
  }
  .technological{
    margin-left: 6px;
    display: flex;
    align-items: center;
    .pay_advance{
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      .advance_indicate{
        display: flex;
        align-items: center;
        .instructions{
          width: 16px;
          height: 16px;
          background: #FF0E25;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 17px;
        }
        .instructions_xian{
          width: 142px;
          height: 1px;
          background: #FF0E25;
        }
        .instructions_kong{
          width: 142px;
          height: 1px;
        }
      }
      .advance_title{
        margin-top: 10px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 20px;
      }
      .advance_time{
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 17px;
        margin-top: 2px;
      }
    }
    .pay_balance{
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      .balance_indicate{
        display: flex;
        align-items: center;
        .instructions{
          width: 16px;
          height: 16px;
          background: #999999;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 17px;
        }
        .instructions_xian{
          width: 142px;
          height: 1px;
          background: #D8D8D8;
        }
        .instructions_kong{
          width: 142px;
          height: 1px;
          background: #D8D8D8;
        }
      }
      .advance_title{
        margin-top: 10px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 20px;
      }
      .advance_time{
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 17px;
        margin-top: 2px;
      }
    }
    .shipments{
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      .balance_indicate{
        display: flex;
        align-items: center;
        .instructions{
          width: 16px;
          height: 16px;
          background: #999999;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 17px;
        }
        .instructions_xian{
          width: 142px;
          height: 1px;
        }
        .instructions_kong{
          width: 142px;
          height: 1px;
          background: #D8D8D8;
        }
      }
      .advance_title{
        margin-top: 10px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 20px;
      }
      .advance_time{
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 17px;
        margin-top: 2px;
      }
    }
  }
}
.bill_monad {
  width: 100%;
  height: auto;
  img {
    width: 100%;
    height: auto;
  }
}
</style>
